export default "__VITE_PUBLIC_ASSET__ec557c85__"